import UserPreferencesTable from "@/app/app-shared/user-preference/user-preference-table";

export default function UserPreferencePage() {
  return <UserPreferencesTable />;
}
